// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3GVIb{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._5gPx9{color:#2a343e;font-size:16px;font-size:1.6rem;font-weight:700;line-height:16px;line-height:1.6rem;margin:1.6rem}._3-TXu{fill:#2a343e;padding:1.6rem;stroke:#2a343e}._3lOzn{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}._3tpP_{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:0 1.6rem}._2pMYT{height:auto;padding:1.6rem .8rem;width:auto}.nlJZo{display:none}@media print{.nlJZo{display:block}}", ""]);
// Exports
exports.locals = {
	"viewer__nav": "_3GVIb",
	"viewer__navPagination": "_5gPx9",
	"viewer__navIcon": "_3-TXu",
	"viewer__navIcon--right": "_3lOzn",
	"viewer__bottomNav": "_3tpP_",
	"viewer__bottomNavIcon": "_2pMYT",
	"viewer__hiddenPages": "nlJZo"
};
module.exports = exports;
